export class FormatStrings {
  public static formatNumbersToHuman(sourceString): string {
    return sourceString.replace(/\s/gi, '').replace(/\D^[\-]/gi, '').replace(/\B(?=(\d{3})+(?!\d))/g,  ' ')
  }

  public static formatDecimalToHuman(sourceString, emptyValue: string = ''): string {
    if (typeof(sourceString) !== 'undefined') {
      const arr = sourceString.toString().split('.')
      arr[0] = FormatStrings.formatNumbersToHuman(arr[0])

      return arr.join('.')
    } else {
      return emptyValue
    }
  }

  public static formatPassport(sourceString) {
    const str = /([а-яА-Яa-zA-Z0-9]{4})([а-яА-Яa-zA-Z0-9]+)/

    return sourceString.replace(/\s/gi, '').replace(/[^а-яА-Яa-zA-Z0-9]/gi, '').replace(str, '$1 $2')
  }
}
